import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=c916634c&scoped=true&"
import script from "./Help.vue?vue&type=script&setup=true&lang=js&"
export * from "./Help.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Help.vue?vue&type=style&index=0&id=c916634c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c916634c",
  null
  
)

export default component.exports